import React, { createContext, useState, useEffect, useContext } from 'react'

import PropTypes from 'prop-types'
import { useSearchParams } from 'react-router-dom'

const AppMediumContext = createContext()

export const useAppMedium = () => {
  const context = useContext(AppMediumContext)
  if (!context) {
    throw new Error('useAppMedium must be used within a AppMediumProvider')
  }
  return context
}

export const MOBILE_APP_MEDIUM = 'mobile-app'
export const DESKTOP_APP_MEDIUM = 'desktop-app'

export const SEARCH_PARAMS = {
  MEDIUM: 'medium',
}

export const LS_PARAMS = {
  APP_MEDIUM: 'app-medium',
}

export const AppMediumProvider = ({ children }) => {
  const [searchParams] = useSearchParams()
  const [isMobileDevice, setIsMobileDevice] = useState(false)

  const values = { isMobileDevice }

  useEffect(() => {
    const medium = searchParams?.get(SEARCH_PARAMS.MEDIUM)
    const currentState = localStorage.getItem(LS_PARAMS.APP_MEDIUM)
    if (currentState === MOBILE_APP_MEDIUM) setIsMobileDevice(true)

    if (!currentState && medium === MOBILE_APP_MEDIUM) {
      localStorage.setItem(LS_PARAMS.APP_MEDIUM, medium)
      setIsMobileDevice(true)
    }
  }, [])

  return (
    <AppMediumContext.Provider value={values}>
      {children}
    </AppMediumContext.Provider>
  )
}

AppMediumProvider.propTypes = {
  children: PropTypes.any,
}

export default AppMediumProvider
